(() => {
  "use strict";

  // Collection card callouts
  const CALLOUTS = {
    "aura-smart-air-purifier": {
      bold: "High demand",
      text: "Pre-order ongoing"
    },
    "vortex-2c-air-purifier": {
      bold: "High demand",
      text: "Pre-order ongoing"
    },
    "vortex-pro-2-air-purifier": {
      bold: "High demand",
      text: "Ready stock available"
    },
    "prism-aero-air-purifier": {
      bold: "High demand",
      text: "Ready stock available"
    },
    "prism-aero-ultra-air-purifier": {
      bold: "High demand",
      text: "Ready stock available"
    },
    "prism-vortex": {
      bold: "High demand",
      text: "Ready stock available"
    },
    "prism-vortex-pro": {
      bold: "High demand",
      text: "Pre-order ongoing"
    }
  };

  // PDP-only callouts for Vortex and Vortex Pro
  const PDP_CALLOUTS = {
    "aura-smart-air-purifier": {
      bold: "High demand",
      text: "Pre-order ongoing."
    },
    "prism-aero-air-purifier": {
      bold: "High Demand: Stock running out fast",
    },
    "vortex-2c-air-purifier": {
      bold: "High Demand: Stock running out fast",
      text: "Airshipped pre-order from 30th October, limited qty.",
      detail: "Delivery estimates are on a best-effort basis and subject to stock availability."
    },
    "vortex-pro-2-air-purifier": {
      bold: "High Demand: Stock running out fast",
      text: ""
    },
    "prism-aero-ultra-air-purifier": {
      bold: "High Demand: Stock running out fast",
      text: ""
    },
    "prism-vortex": {
      bold: "High Demand: Stock running out fast",
      text: "Ready stock for Vortex Cannoli Cream, limited qty. <br>Expedited pre-order from end October to early November for Arctic White and Onyx Black",
      detail: "Delivery estimates are on a best-effort basis and subject to stock availability."
    },
    "prism-vortex-pro": {
      bold: "High Demand: Stock running out fast",
      text: "Expedited pre-order from end October to early November.",
      detail: "Delivery estimates are on a best-effort basis and subject to stock availability."
    }
  };

  const ICON =
    '<svg class="ap-callout__icon" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>' +
    "</svg>";

  const CSS = `
    .ap-callout {
      background: #CE7A2C33;
      color: #252525;
      font-family: "Open Sans", sans-serif;
    }

    .ap-callout--card {
      margin: 0 auto 8px;
      padding: 8px 6px;
      font-size: 12px;
      text-align: center;

      display: flex;
      justify-content: center;
      align-items: center;
    }

    .ap-callout--pdp {
      margin: 0 0 20px;
      padding: 20px;
      border: 1px solid #CE7A2C;
      font-size: 16px;
      text-align: left;
    }

    .ap-callout__lead,
    .ap-callout__text {
      white-space: nowrap;

    }

    .ap-callout__lead {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      vertical-align: top;
    }

    .ap-callout__icon {
      flex: 0 0 auto;
      width: 20px;
      height: 20px;
      fill: #c0702e;
    }

    .ap-callout strong {
      font-weight: 600;
      padding-left: 2px;
    }
    .ap-callout__dot{
      padding: 0 3px;
    }
    .ap-callout--stacked .ap-callout__dot {
      display: none;
    }
    .ap-callout--card.ap-callout--stacked {
      flex-direction: column;
    }
    
    .v_hoverWrap.prism-vortex .ap-callout--card.ap-callout--stacked span.ap-callout__text span:last-child{
      letter-spacing: auto;
    }

    .ap-callout--pdp.ap-callout--detailed {
      display: grid;
      grid-template-columns: auto 1fr;
      column-gap: 8px;
    }

    .ap-callout--detailed .ap-callout__lead {
      grid-column: 1 / -1;
    }

    .ap-callout--detailed .ap-callout__text,
    .ap-callout--detailed .ap-callout__detail {
      grid-column: 2;
      white-space: normal;
      font-size: 14px;
      padding-left: 20px;
    }

    .ap-callout__detail {
      display: block;
    }

    @media (max-width: 539px) {
      .ap-callout--card {
        padding: 6px 4px;
      }

      .ap-callout--pdp {
        padding: 12px;
        font-size: 12px;
      }

      .ap-callout__icon {
        width: 16px;
        height: 16px;
      }
    }


    .v_hoverWrap.prism-vortex span.ap-callout__text span:last-child,
    .prism-aero-a1 span.ap-callout__text span:last-child,
    .prism-aero-ultra-air-purifier span.ap-callout__text span:last-child, .prism-aero-ultra-new span.ap-callout__text span:last-child,
    .v_hoverWrap.prism-vortex-pro-2-led-plate span.ap-callout__text span:last-child {
      font-weight: 600;
      position: relative;
      letter-spacing: -1px;
    }
    .v_hoverWrap.prism-vortex span.ap-callout__text span:last-child:after,
    .prism-aero-a1 span.ap-callout__text span:last-child:after,
    .prism-aero-ultra-air-purifier span.ap-callout__text span:last-child:after, .prism-aero-ultra-new span.ap-callout__text span:last-child:after,
    .v_hoverWrap.prism-vortex-pro-2-led-plate span.ap-callout__text span:last-child:after {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
      height: 1px;
      background: #127128;
      bottom: -2px;
    }
    .v_hoverWrap.prism-vortex .ap-callout__icon,
    .prism-aero-a1 .ap-callout__icon,
    .prism-aero-ultra-air-purifier .ap-callout__icon, .prism-aero-ultra-new .ap-callout__icon,
    .v_hoverWrap.prism-vortex-pro-2-led-plate .ap-callout__icon {
      fill: #127128;
    }
    .v_hoverWrap.prism-vortex .ap-callout.ap-callout--card,
    .prism-aero-a1 .ap-callout.ap-callout--card,
    .prism-aero-ultra-air-purifier .ap-callout.ap-callout--card, .prism-aero-ultra-new .ap-callout.ap-callout--card, 
    .v_hoverWrap.prism-vortex-pro-2-led-plate .ap-callout.ap-callout--card {
      color: #127128;
      background: #CDEDE5;
    }
  `;

  function addStyles() {
    if (document.getElementById("ap-callout-styles")) return;

    const style = document.createElement("style");
    style.id = "ap-callout-styles";
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  // Works for /products/<handle> and /collections/<x>/products/<handle>.
  function getHandle(url) {
    const match = url && url.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function createCallout(handle, modifier) {
    const callout =
      modifier === "pdp" && PDP_CALLOUTS[handle]
        ? PDP_CALLOUTS[handle]
        : CALLOUTS[handle];

    if (!callout) return null;

    const el = document.createElement("div");
    el.className = "ap-callout ap-callout--" + modifier;

    if (callout.detail) {
      el.classList.add("ap-callout--detailed");
    }

const hasText = typeof callout.text === "string" && callout.text.trim() !== "";

el.innerHTML =
  '<span class="ap-callout__lead">' +
  ICON +
  "<strong></strong></span> " +
  '<span class="ap-callout__text"><span class="ap-callout__dot' +
  (hasText ? "" : " hidden") +
  '">&bull;</span><span></span></span>' +
  (callout.detail ? '<span class="ap-callout__detail"></span>' : "");

el.querySelector("strong").textContent = callout.bold;

const textEl = el.querySelector(".ap-callout__text span:last-child");
(callout.text || "").split(/<br\s*\/?>/i).forEach((part, index) => {
  if (index > 0) textEl.appendChild(document.createElement("br"));
  textEl.appendChild(document.createTextNode(part));
});



    if (callout.detail) {
      el.querySelector(".ap-callout__detail").textContent = callout.detail;
    }

    return el;
  }

  // Collection cards: read the product handle from the Shop Now link.
  function initCollection() {
    document.querySelectorAll(".v_hoverWrap .grid_shop").forEach((shop) => {
      if (shop.querySelector(".ap-callout")) return;

      const link = shop.querySelector('a[href*="/products/"]');
      const handle = getHandle(link && link.getAttribute("href"));
      const el = createCallout(handle, "card");

      if (!el) return;

      shop.prepend(el);
      resizeObserver.observe(el);
    });
  }

  // Product page: insert the callout before the main product form.
  function initProduct() {
    const form = document.querySelector(".info_wrap form.product-form");
    if (!form || document.querySelector(".ap-callout--pdp")) return;

    const handle = getHandle(location.pathname);
    const el = createCallout(handle, "pdp");

    if (!el) return;

    form.before(el);
    resizeObserver.observe(el);
  }

  function fit(el) {
    // el.classList.remove("ap-callout--stacked");

    // const lead = el.querySelector(".ap-callout__lead");
    // const text = el.querySelector(".ap-callout__text");

    // if (!lead || !text) return;

    // const leadRect = lead.getBoundingClientRect();
    // const textRect = text.getBoundingClientRect();

    // const isStacked = textRect.top > leadRect.top + 2;

    // el.classList.toggle("ap-callout--stacked", isStacked);
    
    if (window.innerWidth >= 1200) {
      el.classList.remove("ap-callout--stacked");
    } else {
      el.classList.add("ap-callout--stacked");
    }
  }

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => fit(entry.target));
  });

  function init() {
    addStyles();

    if (getHandle(location.pathname)) {
      initProduct();
    } else {
      initCollection();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();